import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import AuthenticationService from '@/service/AuthenticationService';

Vue.use(Vuex)
import VuexPersist from 'vuex-persist'

const vuexPersist = new VuexPersist({
  key: 'iamdavidmt-user-com',
  storage: localStorage
})

function initialState() {
  return {
    username: null,
    userId: null,
    email: null,
    token: null,
    permission: null
  }
}

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: initialState(),
  getters: {
    getUsername(state) {
      return state.username
    },
    getUserId(state) {
      return state.userId
    },
    getToken(state) {
      return state.token
    },
    getPermission(state) {
      return state.permission
    },
    isAdmin(state) {
      if(state.permission){
        return state.permission.includes('ADMIN');
      }
    },
    isEditor(state) {
      if(state.permission){
        return state.permission.includes('EDITOR');
      }
    },
    isAuthenticated(state) {
      return state.token !== null
    }
  },
  mutations: {
    updateUsername(state, username) {
      state.username = username
    },
    updatePermission(state, permission) {
      state.permission = permission
    },
    updateUserId(state, userId) {
      state.userId= userId
    },
    updateEmail(state, email) {
      state.email= email
    },
    updateToken(state, token) {
      state.token = token
    },
    logout(state) {
      Object.keys(initialState()).forEach(key => {
        state[key] = initialState()[key]
      })
    }
  },
  actions: {
    logout({commit}) {
      commit('logout')
    },
    setToken({commit}, {username, password}) {
      return new Promise((fulfill, reject) => {
        axios.post(`/auth/generate`, {
          username: username,
          password: password,
        }).then(response => {
          commit('updateToken', response.data.token)
          fulfill(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setUser({commit}, {token}) {
      return new Promise((fulfill, reject) => {
        AuthenticationService.authenticateJwt(token).then(response => {
            commit('updateUsername', response.data.username)
            commit('updateEmail', response.data.email)
            commit('updatePermission', response.data.permission)
            commit('updateUserId', response.data.id)
            fulfill(response)
          }).catch(error => {
          reject(error)
        })
      })
    },
  }
})
